import React from "react";
import { CheckCircle2, Microscope, Scale, Users } from "lucide-react";
import livestockImg from "../assets/livestock-2.jpg";

const Livestock = () => {
  const highlights = [
    { label: "Breed Lineage", value: "Pure Nellore Jodipi", icon: <Users size={14} /> },
    { label: "Avg. Birth Wt", value: "3.5kg - 4.2kg", icon: <Scale size={14} /> },
    { label: "Health Status", value: "Brucellosis Free", icon: <Microscope size={14} /> },
  ];

  return (
    <section className="py-12 bg-[#FDFCF8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-10">
          
          <div className="w-full lg:w-1/2 relative">
            <div className="aspect-[3/2] rounded-3xl overflow-hidden shadow-xl border-[8px] border-white bg-gray-100">
              <img 
                src={livestockImg} 
                alt="Premium Livestock" 
                className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105" 
              />
            </div>
            
            <div className="absolute -bottom-2 -right-2 bg-[#2D5A27] text-white p-5 rounded-2xl shadow-lg hidden md:block z-10">
              <p className="text-2xl font-black tracking-tighter leading-none">98%</p>
              <p className="text-[8px] font-bold uppercase tracking-widest opacity-80 mt-1">Survival Rate</p>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="text-[9px] font-black uppercase tracking-[0.4em] text-[#D4AF37] mb-2 block">
              Elite Breeding Stock
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-[#4B3621] tracking-tighter mb-4 leading-tight">
              Genetics Engineered for <br />
              <span className="text-[#2D5A27]">Maximum Yield.</span>
            </h2>
            
            <p className="text-gray-500 font-medium text-sm leading-relaxed mb-6">
              Our selection represents the pinnacle of Nellore Jodipi. 
              Through meticulous stall-fed management, we ensure optimum 
              bone structure and muscle distribution across the flock.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
              {highlights.map((item, i) => (
                <div key={i} className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                  <div className="text-[#D4AF37] mb-2">{item.icon}</div>
                  <p className="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-0.5">{item.label}</p>
                  <p className="text-xs font-bold text-[#4B3621]">{item.value}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
              {["DNA Verified Pedigree", "Electronic Tagging", "Strict Quarantine", "Vaccination Records"].map((feature, i) => (
                <div key={i} className="flex items-center gap-2 text-[#4B3621] font-bold text-[10px] uppercase tracking-tight">
                  <CheckCircle2 size={14} className="text-[#2D5A27]" />
                  {feature}
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Livestock;